import { AnnouncementUI, initAnnouncement } from './Announcements'

export enum FunnelStep {
  Customise = 1,
  Extras,
  Details,
  Confirm,
}

export interface UI {
  viewGiftcardModal: boolean
  viewPersonModal: boolean
  viewTransportModal: boolean
  viewThanksGivingModal: boolean
  viewCalendarModal: boolean
  viewRocketModal: boolean
  viewActionListModal: boolean
  viewSummary: boolean
  funnelStep: FunnelStep
  hideTotalTrigger: boolean
  announcements: AnnouncementUI
  homeCarouselScroll: number

  priceError?: any
}

export const initialUI: UI = {
  viewGiftcardModal: false,
  viewPersonModal: false,
  viewTransportModal: false,
  viewThanksGivingModal: false,
  viewCalendarModal: false,
  viewRocketModal: false,
  viewActionListModal: false,
  viewSummary: false,
  funnelStep: FunnelStep.Customise,
  hideTotalTrigger: false,
  announcements: initAnnouncement,
  homeCarouselScroll: 0,
}
